<template>
  <main class="main main--terms">
    <component
      :is="statementContent"
      class="group group--first-last group--indent typeset typeset--terms links"
    />
  </main>
</template>

<script>
// Models
import meta from 'models/meta';
import statementContent from 'models/content/statement.md';

// Utils
import { createMeta } from 'utils/meta';

// Export
export default {
  name: 'view-statement',

  // Meta data
  metaInfo: {
    title: meta.terms.title,
    meta: createMeta(meta.terms.meta),
  },

  // Data
  data() {
    return {
      statementContent,
    };
  },
};
</script>



// WEBPACK FOOTER //
// Statement.vue?551d05d7